/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {DragPlaceholderComponent as ɵa} from './lib/drag-placeholder/drag-placeholder.component';